<template>
	<v-app id="app-container">
		<component :is="this.$route.meta.layout || 'div'">
			<router-view />
		</component>
	</v-app>
</template>

<script>
import { mapGetters } from 'vuex';
import { AmplifyEventBus } from 'aws-amplify-vue';
import 'crypto-js/lib-typedarrays';
import { Auth } from 'aws-amplify';

window.sib = {
	equeue: [],
	client_key: import.meta.env.VITE_BREVO_CLIENT_KEY || 'xyrlollxytmewfy9yob15',
};

/* OPTIONAL: email for identify request*/
// window.sib.email_id = 'example@domain.com';
window.sendinblue = {};
for (var j = ['track', 'identify', 'trackLink', 'page'], i = 0; i < j.length; i++) {
	(function (k) {
		window.sendinblue[k] = function () {
			var arg = Array.prototype.slice.call(arguments);
			(
				window.sib[k] ||
				function () {
					var t = {};
					t[k] = arg;
					window.sib.equeue.push(t);
				}
			)(arg[0], arg[1], arg[2]);
		};
	})(j[i]);
}
var n = document.createElement('script');
i = document.getElementsByTagName('script')[0];
(n.type = 'text/javascript'),
	(n.id = 'sendinblue-js'),
	(n.async = !0),
	(n.src = 'https://sibautomation.com/sa.js?key=' + window.sib.client_key),
	i.parentNode.insertBefore(n, i),
	window.sendinblue.page();

export default {
	name: 'App',

	components: {},

	data: () => ({
		signedIn: Boolean,
	}),

	computed: {
		...mapGetters('tenant', ['tenant']),

		tawkActive() {
			return (
				this.tenant &&
				this.tenant.settings &&
				this.tenant.settings.workflow &&
				this.tenant.settings.workflow.support &&
				this.tenant.settings.workflow.support.tawk &&
				this.tenant.settings.workflow.support.tawk.active
			);
		},
	},

	beforeCreate() {
		AmplifyEventBus.$on('authState', info => {
			if (info === 'signedIn') {
				this.signedIn = true;
				this.$router.push('/dashboard');
			}
			if (info === 'signedOut') {
				this.$router.push('/');
				this.signedIn = false;
			}
		});

		Auth.currentAuthenticatedUser()
			.then(() => {
				this.signedIn = true;
			})
			.catch(() => (this.signedIn = false));

		const vm = this;

		window.Tawk_API = window.Tawk_API || {};
		window.Tawk_API.onBeforeLoad = function () {
			if (!vm.tawkActive) {
				window.Tawk_API.hideWidget();
			}
		};
	},
};
</script>

<style scoped>
#app-container {
	background-color: var(--v-background-base);
}
</style>
